/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type ShareActivityAlert_user$ref = any;
export type ShareActivityAlert_user = {
    readonly serviceId: string | null;
    readonly preferences: {
        readonly shareActivities: unknown | null;
    } | null;
    readonly " $refType": ShareActivityAlert_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ShareActivityAlert_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "preferences",
            "storageKey": null,
            "args": null,
            "concreteType": "UserPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shareActivities",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '1f8e6e09353d2c2af6a4d8f829b056a1';
export default node;
